import { FaCopy } from "react-icons/fa6";

export const NasDetailInfoItem = ({
    label,
    value,
    isLink,
    onCopy,
    icon,
    enableCopy = true,
}) => {

    const handleItemClick = () => {
        if (enableCopy && !isLink && value && onCopy) {
            onCopy(value);
        }
    };

    return (
        <div className="flex items-center justify-between py-1 group">
            <label className="text-[9px] font-bold text-slate-500 uppercase tracking-widest w-24 flex-shrink-0">
                {label}
            </label>

            <div className="text-right flex items-center gap-2 flex-1">
                {isLink ? (
                    <a
                        href={isLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-bold text-xs text-cyan-400 underline hover:text-cyan-300 transition-colors block max-w-[150px] truncate"
                    >
                        {value}
                    </a>
                ) : (
                    <p
                        className={`
                            font-bold text-xs text-slate-200
                            flex items-center justify-end gap-1
                            max-w-[160px] truncate
                            transition-colors
                            ${enableCopy && value
                                ? "cursor-pointer group-hover:text-cyan-400"
                                : "cursor-default"
                            }
                        `}
                        onClick={enableCopy ? handleItemClick : undefined}
                        title={
                            enableCopy && value
                                ? "Klik untuk menyalin"
                                : undefined
                        }
                    >
                        {icon && (
                            <span className="text-slate-500">
                                {icon}
                            </span>
                        )}

                        <span className="truncate">
                            {value || "-"}
                        </span>

                        {enableCopy && value && (
                            <FaCopy
                                className="
                                    text-[8px]
                                    opacity-0
                                    group-hover:opacity-100
                                    transition-opacity
                                    text-slate-500
                                "
                            />
                        )}
                    </p>
                )}
            </div>
        </div>
    );
};